import classes from "./preOrderText.module.css"

const PreOrderText = (props) => {


  const {
    note, isPreOrder 
  } = props || {
    note: "PREORDER",
    isPreOrder: false
  }

  if (!isPreOrder) { return null }


  return (
    <div className={classes.root}>
      {note}
      {/* Ships within 18 days. */}
    </div>
  )
}

export default PreOrderText
